import axios from 'axios';
import ProjectConfig from 'ProjectConfig';
const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const getCampaignClarificationAgreement = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios({
        url: `${API_GATEWAY}/cms/userAgreement/v2/referans-kampanyasi-aydinlatma-metni/latest`,
        method: 'get'
      });
  
      resolve(res);
    } catch (e) {
      reject(e);
    }
  });
};

export const getCampaigAgreement = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios({
        url: `${API_GATEWAY}/cms/userAgreement/v2/referans-kampanyasi-kampanya-kosullari/latest`,
        method: 'get'
      });
    
      resolve(res);
    } catch (e) {
      reject(e);
    }
  });
};